import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Row, Col } from "react-bootstrap"
//import ScrollAnimation from "react-animate-on-scroll";
import HTMLReactParser from 'html-react-parser';
import PlayVideo from "../../Play/custom-video";

import { MEET_THE_TEAM_PAGE_URL } from "../../common/site/constants";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import Slider from "react-slick";
import _ from "lodash"

import "./OurTeam.scss"
// markup

const Team = (props) => {
    let [isPlay, setPlay] = React.useState(false);

    const settings = {
        dots: true,
        lazyLoad: true,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1

                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            },
        ],
    }
    const suffleData = _.slice(_.shuffle(props.data), 0, 4);

    const ImageRender = ({ image_url, node, processedImages }) => {
        return (
        //   <ImageTransform 
        //   imagesources={image_url} 
        //   renderer="srcSet" 
        //   imagename="peoples.Tile_Image.tile" 
        //   attr={{ alt: node.Name + ' - Dacha', class: '' }} 
        //   imagetransformresult={processedImages} 
        //   id={node.id} />
        <ImageModule 
            ImageSrc={image_url } 
            attr={{ alt:node.Name + ' - Dacha', class: '' }} 
            ggfx_results={node?.ggfx_results} 
            imagename="peoples.Tile_Image.tile"  
            strapi_id={node?.id} 
        /> 
        )
    }
    return (
        <React.Fragment>
            <section className="our-team team-slider-wrapper sec-pdy-120">
                    <Container>
                        <div className="about-team-header">
                                <Row>
                                    <div className="col-md-9">
                                        {props.title &&
                                            <h4>{props.title}</h4>
                                        }
                                        {props.intro &&
                                            <div className="strap-line text-sm">
                                                {HTMLReactParser(props.intro.replace(/\n/g, ''))}
                                            </div>
                                        }
                                    </div>
                                    <div className="col-md-3">
                                        <div className="team-btn">
                                          <Link className="btn btn-outline btn-outline-dark" to={`${MEET_THE_TEAM_PAGE_URL.alias}`}>Meet the full team</Link>
                                        </div>
                                    </div>
                                </Row>
                        </div>
                        <div className="about-team-list">
                        {props.layout !== "Service_Landing" &&
                            <Slider  {...settings}>

                                {props.data && props.data.map((people, i) => {

                                    const image_url = people.Tile_Image.url

                                    let processedImages = JSON.stringify({});
                                    if (people?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = people.imagetransforms.Tile_Image_Transforms;
                                    }

                                    return (
                                        <div className="slider-wrapper">
                                            <div className="team-wrapper">
                                                <div className="team-member-img-wrap img-zoom">
                                                    <Link to={`${MEET_THE_TEAM_PAGE_URL.alias}/${people.URL}`}> <ImageRender processedImages={processedImages} image_url={people.Tile_Image} node={people} />
                                                    </Link>
                                                    {people.Video_URL &&
                                                        <div className="banner-btn people-video-btn">
                                                            <PlayVideo url={people.Video_URL} />
                                                        </div>
                                                    } 
                                                </div>                                                
                                                <div className="team-info">
                                                <Link to={`${MEET_THE_TEAM_PAGE_URL.alias}/${people.URL}`}>
                                                        <div className="member-name text-md-bold">{people.Name}</div>
                                                        <div className="member-designation text-xxs">{people.Designation}</div>
                                                </Link>                                                
                                                </div>
                                            </div>

                                        </div>
                                    )
                                })}
                            </Slider>
                        }
                        {props.layout === "Service_Landing" &&
                            <div className="row">
                                {suffleData && suffleData.map((people, i) => {
                                    return (
                                        <div className="col-lg-3 col-md-6">
                                            <div className="team-wrapper">
                                                <div className="team-member-img-wrap img-zoom">
                                                    <Link to={`${MEET_THE_TEAM_PAGE_URL.alias}/${people.URL}`}>
                                                        <picture>
                                                            <source media="(min-width:1200px)" srcSet={`${people.Tile_Image.url}`} />
                                                            <source media="(min-width:768px)" srcSet={`${people.Tile_Image.url}`} />
                                                            <img loading="lazy" src={`${people.Tile_Image.url}`} alt={people.Tile_Image.alternativeText ? people.Tile_Image.alternativeText : people.Name} />
                                                        </picture>
                                                    </Link>
                                                    {people.Video_URL &&
                                                        <div className="banner-btn">
                                                            <PlayVideo url={people.Video_URL} />
                                                        </div>
                                                    }
                                                </div>
                                                <div className="team-info">
                                                <Link to={`${MEET_THE_TEAM_PAGE_URL.alias}/${people.URL}`}>
                                                    <div className="member-name text-md-bold">{people.Name}</div>
                                                    <div className="member-designation text-xxs">{people.Designation}</div>
                                                </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        </div>
                        {props.layout !== "Service_Landing" &&
                            <div className="btn-row justify-content-center d-none">
                                <Link variant="outline" to={`${MEET_THE_TEAM_PAGE_URL.alias}`} className="btn btn-outline-dark btn-load-more">Load More</Link>
                            </div>
                        }
                    </Container>
            </section>
        </React.Fragment>
    )
}

export default Team;